import script from "./ProfileArtWork.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileArtWork.vue?vue&type=script&setup=true&lang=js"

import "./ProfileArtWork.vue?vue&type=style&index=0&id=512f06ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512f06ce"]])

export default __exports__